const STORAGE_KEY = 'ego-world-bootstrap-cache:v1';
const TTL_MS = 60_000;
const MAX_BYTES = 200_000;

function safeStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function stripVolatile(bootstrap) {
  const agents = Array.isArray(bootstrap?.agents) ? bootstrap.agents : [];
  const nextAgents = agents.map((agent) => {
    if (!agent || typeof agent !== 'object') return agent;
    const copy = { ...agent };
    delete copy.tasks;
    delete copy.life_sim;
    return copy;
  });
  return {
    openclaw_connected: bootstrap?.openclaw_connected ?? false,
    world_state: bootstrap?.world_state ?? null,
    agents: nextAgents,
  };
}

export function readCachedBootstrap(userId) {
  const store = safeStorage();
  if (!store || !userId) return null;
  const raw = store.getItem(STORAGE_KEY);
  if (!raw) return null;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    store.removeItem(STORAGE_KEY);
    return null;
  }
  if (!parsed || parsed.userId !== userId) return null;
  if (typeof parsed.savedAt !== 'number') return null;
  if (Date.now() - parsed.savedAt > TTL_MS) return null;
  if (!parsed.bootstrap) return null;
  return { bootstrap: parsed.bootstrap, savedAt: parsed.savedAt };
}

export function writeCachedBootstrap(userId, bootstrap) {
  const store = safeStorage();
  if (!store || !userId || !bootstrap) return;
  const entry = {
    userId,
    savedAt: Date.now(),
    bootstrap: stripVolatile(bootstrap),
  };
  let serialized;
  try {
    serialized = JSON.stringify(entry);
  } catch {
    return;
  }
  if (serialized.length > MAX_BYTES) return;
  try {
    store.setItem(STORAGE_KEY, serialized);
  } catch {
    // Quota exceeded or storage locked — silently drop.
  }
}

export function clearCachedBootstrap() {
  const store = safeStorage();
  if (!store) return;
  try {
    store.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
